<div class="placement-categories-container">
	<div
		*ngFor="let category of placementCategories"
		class="placement-category-card-container"
		(click)="selectPlacementCategory(category)"
		[ngClass]="{ 'selected': category.id == selectedPlacementCategory?.id }"
		>
		<div class="branding--select-category-card branding--select-category-card--{{category.id}}">
			<div class="branding--select-category-card--label branding--select-category-card--label--{{category.id}}">
				{{ category.label }}
			</div>
			<div class="branding--select-category-card--image branding--select-category-card--image--{{category.id}}"></div>
			<div class="branding--select-category-card--description branding--select-category-card--description--{{category.id}}">
				{{ category.description }}
			</div>
		</div>
	</div>
</div>
